
/**
* 时间戳转格式化时间
**/
export const getTime = (timestamp, format) => {
	var date = new Date(timestamp); 
	return getDateTime(date, format);
}

/**
* 获取当前格式化时间
**/
export const getCurrentTime = (format) => {
	var date = new Date(); 
	return getDateTime(date, format);
}

/**
* 时间格式化
**/
export const getDateTime = (date, format) => { 
	let config = {
		yyyy: '',
		MM: '',
		dd: '',
		hh: '',
		mm: '',
		ss: '',
	};

	config.yyyy = date.getFullYear();
	config.MM = (date.getMonth() + 1 < 10 ? '-' + '0' + (date.getMonth() + 1) : '-' + date.getMonth() + 1);
	config.dd = date.getDate() < 10 ? '-' + '0' + date.getDate() : '-' + date.getDate();
	config.hh = ' ' + (date.getHours() < 10 ? '0' + date.getHours():date.getHours());
	config.mm = ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes():date.getMinutes());
	config.ss = ':' + (date.getSeconds() < 10 ? '0' + date.getSeconds():date.getSeconds());

	let result = '';
	for (let item in config) {
		if (format.indexOf(item) != -1) {
			result += config[item];
		}
	}
	return result;
}

export const generateRandomString = (length) => {
    const characters = 'ABCDEFGHI0123456789JKLMNOPQRS0123456789TUVWXYZ0123456789abcdefghi0123456789jklmnopqrs0123456789tuvwxyz0123456789$&@!#%';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const isDecimal = (value) => {
	const decimalReg = /^[0-9.]*$/
	let data = {};
	if (value) {
		if (decimalReg.test(value)) {
			data["result"] = true;
		} else {
			data["result"] = false;
			data["message"] = "不是数值型";
		}
	} else {
		data["result"] = false;
		data["message"] = "不能为空";
	}
	return data;
}

export const isInt = (value) => {
	const decimalReg = /^[0-9]*$/
	let data = {};
	if (value) {
		if (decimalReg.test(value)) {
			data["result"] = true;
		} else {
			data["result"] = false;
			data["message"] = "不是整型";
		}
	} else {
		data["result"] = false;
		data["message"] = "不能为空";
	}
	return data;
}

export const checkAmount = (rule, value, callback) => {
	const amountReg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
	if (value) {
		setTimeout(() => {
			if (amountReg.test(value)) {
				callback()
			} else {
				callback(new Error('请输入正确的金额'))
			}
		}, 100)
	} else {
		callback(new Error('请输入金额'))
	}
}

export const getQuery = (query, routeParam) => {
	if (routeParam) {
		try {
			for (var key in routeParam) {
				//query[key] = atob(routeParam[key]);
				query[key] = routeParam[key];
			}
		} catch (e) {
			console.log("过滤参数异常")
		}
	}
}